<template>
    <div v-if="show" class="modal-wrapper">
        <form class="modal" @submit.prevent="addFunnel()">
            <h3>Add Funnel</h3>
            <div class="modal-content">
                <div class="field">
                    <label>What is the name of this funnel?</label>
                    <input type="text" v-model="name">
                </div>
            </div>
            <div class="modal-actions">
                <a @click="show = false" href="javascript:;" class="cancel">Cancel</a>
                <button>Next &nbsp; &raquo;</button>
            </div>
        </form>
    </div>
</template>

<script>
export default {
    props: ['app'],
    data() {
        return {
            show: false,
            name: ''
        };
    },
    methods: {
        addFunnel() {
            var _ = this,
                table = 'funnels',
                funnel = {
                    name: _.name
                };

            _.app.requester.request({
                controller: table,
                action: 'save',
                funnel: funnel
            }, function(err, data) {
                _.name = '';
                _.show = false;
                _.app.$router.push(`/funnels/${data.funnels[0].id}`);
            });
        }
    }
};
</script>
